import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const CREATOR_ALLOWED_USER_ID = "50060165";

interface ProtectedCreatorRouteProps {
  children?: React.ReactNode;
}

export const ProtectedCreatorRoute = ({ children }: ProtectedCreatorRouteProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  const isAuthorized = String(user.id) === CREATOR_ALLOWED_USER_ID;
  
  if (!isAuthorized) {
    return <Navigate to="/creator" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
